import { AnimatedSprite, BaseTexture, Texture, Rectangle } from 'pixi.js'
import spritesheetPng from './frames/coinflip.png'
import spritesheetJson from './frames/coinflip.json'

export class Airdrop {
  constructor() {
    this.baseTxt = new BaseTexture(spritesheetPng)
    this.textures = Object.values(spritesheetJson.frames).map(fr => {
      const { x, y, w, h } = fr.frame
      const txt = new Texture(this.baseTxt, new Rectangle(x, y, w, h))
      return txt
    })
    this.airdrop = new AnimatedSprite(this.textures)
    this.airdrop.anchor.set(0.5, 0.5)
    this.airdrop.loop = false
    this.airdrop.y = -200
    this.airdrop.alpha = 0
    this.airdrop.zIndex = 100
    this.airdrop._zIndex = 100
    this.airdrop.name = 'airdrop'
    this.times = 0
    this.container


    this.airdrop.onFrameChange = () => {
      if (this.times > 3) {
        this.airdrop.height -= 1
        this.airdrop.width -= 1
        this.airdrop.y += 3
      }
    }
    this.airdrop.onComplete = () => {

      if (this.times < 7) {
        this.airdrop.gotoAndPlay(0)
        this.airdrop.alpha = 1
        this.times++
        return
      }
      this.airdrop.alpha = 0
      this.times = 0
      this.airdrop.x = 2000

      this.airdrop.height = 50
      this.airdrop.width = 50
      this.airdrop.y = -200
      this.container.removeChild(this.airdrop)
    };
  }
  setContainerForAirdrop = container => this.container = container


  startAirdop = () => {
    this.container.addChildAt(this.airdrop, 0)
    this.airdrop.x = 0
    this.airdrop.alpha = 1
    this.airdrop.gotoAndPlay(0)
  }
}
